import { render, staticRenderFns } from "./FinalDestinationForm.vue?vue&type=template&id=04534928&"
import script from "./FinalDestinationForm.vue?vue&type=script&lang=js&"
export * from "./FinalDestinationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports